const availabilityFilterParam = 'filter.v.availability=1';

function activeFilters() {
  const activeFiltersDesktop = document.querySelectorAll("#ActiveFiltersContainer-desktop a, .facets__header a");
  const activeFiltersMobile = document.querySelectorAll("#ActiveFiltersContainer-mobile a, .facets__header a");
  activeFiltersDesktop.forEach((filter) => { addFilterEventListeners(filter) });
  activeFiltersMobile.forEach((filter) => { addFilterEventListeners(filter) });
}

function addFilterEventListeners(filter) {
  filter.addEventListener("click", (e) => {
    e.preventDefault();
    const url =
      e.currentTarget.href.indexOf("?") == -1
        ? ""
        : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);

    renderContent(url, e);

    const target = e.currentTarget.closest(".js-filter");

    resetActiveFacets(target);
  });
}

const labels = document.getElementsByClassName('filter-option');

for (const label of labels) {
  label.addEventListener('click', function (element) {
    const parent = element.target.closest('.filter');
    parent.classList.toggle('filter--open');
  });
}

Shopify.queryParams = Shopify.queryParams || {};

const debouncedOnSubmit = debounce((event) => {
  onSubmitHandler(event);
}, 500);

const filterAndSortFormDesktop = document.querySelector('#FilteringAndSorting-desktop');
const filterAndSortFormMobile = document.querySelector('#FilteringAndSorting-mobile');
filterAndSortFormDesktop?.addEventListener('input', debouncedOnSubmit.bind(this));
filterAndSortFormMobile?.addEventListener('input', debouncedOnSubmit.bind(this));

const sortSelectorSelect = document.querySelector('select[name="sort-by"]');

if (sortSelectorSelect) {
  sortSelectorSelect.addEventListener('change', function (e) {
    const filters = document.querySelector('#FilteringAndSorting-mobile');
    var event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    filters.dispatchEvent(event);
  });
}

async function onSubmitHandler(e) {
  e.preventDefault();
  const formData = new FormData(e.target.closest('form'));
  let searchParams = new URLSearchParams(formData).toString();
  
  const sortSelect = document.querySelector('select[name="sort-by"]');
  const sortingType = sortSelect ? sortSelect.value : null;
  
  const collectionPage = document.querySelector('.search-page');
  if (sortingType || collectionPage) {
    if (searchParams == undefined && sortingType) searchParams = "sort_by=" + sortingType;
    else {
      if (!searchParams.includes('filter.v.availability')) searchParams = searchParams + '&' + availabilityFilterParam;
      if (searchParams === availabilityFilterParam) searchParams = '';

      const searchParamsArr = searchParams.split('filter');
      if (Array.isArray(searchParamsArr) && collectionPage) {
        if (searchParamsArr.length == 2 && searchParams.includes('filter.v.availability')) searchParams = searchParamsArr[0];
      }
      if (sortingType) {
        searchParams = searchParams + "&sort_by=" + sortingType;
      }
    }
  }
  renderContent(searchParams, e);
}

Shopify.queryParams = Shopify.queryParams || {};

// Preserve existing query parameters
if (location.search.length) {
  var params = location.search.substr(1).split("&");

  for (var i = 0; i < params.length; i++) {
    var keyValue = params[i].split("=");

    if (keyValue.length) {
      Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(
        keyValue[1],
      );
    }
  }
}

function fetchContent(url, e, collectionId) {
  const loading = document.querySelector('[data-loading]');
  if (loading) loading.classList.remove('hidden');
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const parser = new DOMParser();
      const html = parser.parseFromString(responseText, 'text/html');

      replaceContent(html, e, collectionId);
      if (loading) loading.classList.add('hidden');
    });
}

function replaceContent(html, e, collectionId) {
  if (!html) return;

  const filterEls = document.querySelectorAll('#FilteringAndSorting-desktop .filter, #FilteringAndSorting-mobile .filter');

  // replace product grid content
  replaceContentByid(collectionId, html);
  replaceContentBySelector('section[data-section-id="collection-template"] .SectionHeader .SectionHeader__Heading', html);

  // replace active filters content
  replaceContentByid('ActiveFiltersContainer-mobile', html);
  replaceContentByid('ActiveFiltersContainer-desktop', html);

  // replace filters
  replaceFiltersElements(filterEls, html);

  const event = new CustomEvent('product-grid:replaced', {});
  document.dispatchEvent(event);
  window.yotpoWidgetsContainer.initWidgets();
}

function replaceFiltersElements(filterEls, html) {
  filterEls?.forEach((filterGroup) => {
    filterGroup.querySelectorAll('.facets__list > .facet').forEach((checkBoxGroup) => {
      const checkID = checkBoxGroup.id;
      if (checkID) replaceContentByid(checkID, html);
    });
  });
}

function replaceContentBySelector(selector, html) {
  const sourceEl = html.querySelector(selector);
  const destinationEl = document.querySelector(selector);

  if (destinationEl && sourceEl) destinationEl.innerHTML = sourceEl.innerHTML;
}

function replaceContentByid(targetId, html) {
  const sourceEl = html.getElementById(targetId);
  const destinationEl = document.getElementById(targetId);

  if (destinationEl && sourceEl) destinationEl.innerHTML = sourceEl.innerHTML;
}

function resetActiveFacets(target) {
  if (!target) return;
  const targetElements = target.querySelectorAll('.facets__list li input');

  targetElements.forEach((element) => {
    element.checked = false;
  });
}

function replaceFilterElements(html, e) {
  const filterElements = html.querySelectorAll('#FilteringAndSorting .js-filter, #FilteringAndSortingMobile .js-filter');

  const matchesIndex = (element) => {
    const jsFilter = e ? e.target.closest('.js-filter') : undefined;
    return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
  };

  const otherFacetsToRender = Array.from(filterElements).filter((element) => !matchesIndex(element));
  const facetToRender = Array.from(filterElements).find(matchesIndex);

  otherFacetsToRender.forEach((element) => {
    document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
  });

  if (facetToRender) replaceCurrentFacet(facetToRender, e.target.closest('.js-filter'));

  activeFilters();
}

function replaceCurrentFacet(source, target) {
  const targetElement = target.querySelector('.facets__header');
  const sourceElement = source.querySelector('.facets__header');

  if (sourceElement && targetElement) {
    targetElement.outerHTML = sourceElement.outerHTML;
  }
}

function getSections() {
  return [
    {
      sectionId: document.querySelector('.CollectionInner__Products')?.dataset.id,
    },
  ];
}

function renderContent(urlParams, e) {
  const sections = getSections();

  updateURLHash(urlParams);
  sections.forEach((section) => {
    const url = `${window.location.pathname}?${urlParams}`;
    const id = section.sectionId
    fetchContent(url, e, id);
  });
}

function updateURLHash(urlParams) {
  history.pushState({ urlParams }, '', `${window.location.pathname}${urlParams && '?'.concat(urlParams)}`);
}

window.addEventListener('DOMContentLoaded', function () {
  function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromSlider, toSlider, toSlider);
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
    } else {
      fromSlider.value = from;
    }
  }

  function controlToInput(toSlider, fromInput, toInput, controlSlider) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromSlider, toSlider, toSlider);
    setToggleAccessible(toInput);
    if (from <= to) {
      toSlider.value = to;
      toInput.value = to;
    } else {
      toInput.value = from;
    }
  }

  function controlFromSlider(fromSlider, toSlider, fromInput) {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, toSlider);
    if (fromSlider.value !== fromSlider.min) {
      if (from > to) {
        fromSlider.value = to;
        fromInput.value = to;
      } else {
        fromInput.value = from;
      }
    } else {
      fromInput.value = '';
    }
  }

  function controlToSlider(fromSlider, toSlider, toInput) {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, toSlider);
    setToggleAccessible(toSlider);
    if (toSlider.value !== toSlider.max) {
      if (from <= to) {
        toSlider.value = to;
        toInput.value = to;
      } else {
        toInput.value = from;
        toSlider.value = from;
      }
    } else {
      toInput.value = '';
    }
  }

  function getParsed(currentFrom, currentTo) {
    const from = parseInt(currentFrom.value, 10);
    const to = parseInt(currentTo.value, 10);
    return [from, to];
  }

  function fillSlider(from, to, controlSlider) {
    const rangeDistance = to?.max - to?.min;
    const fromPosition = from?.value - to?.min;
    const toPosition = to?.value - to?.min;
    const sliderColor = 'rgb(229, 229, 229, 0)';
    let rangeColor = '#6a6a6a';
    if (controlToSlider) {
      controlSlider.style.background = `linear-gradient(
        to right,
        ${sliderColor} 0%,
        ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
        ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
        ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
        ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
        ${sliderColor} 100%)`;
    }
  }

  function setToggleAccessible(currentTarget) {
    const toSliderDesktop = document.querySelector('#toSlider-desktop');
    const toSliderMobile = document.querySelector('#toSlider-mobile');
    if (Number(currentTarget.value) <= 0) {
      toSliderDesktop.style.zIndex = 2;
      toSliderMobile.style.zIndex = 2;
    } else {
      toSliderDesktop.style.zIndex = 0;
      toSliderMobile.style.zIndex = 0;
    }
  }

  function updateSliderText(fromSlider, toSlider) {
    const fromValue = fromSlider.value;
    const toValue = toSlider.value;
    const fromTextFieldDesktop = document.querySelector('#filter_price_min_show-desktop');
    const fromTextFieldMobile = document.querySelector('#filter_price_min_show-mobile');
    const toTextFieldDesktop = document.querySelector('#filter_price_max_show-desktop');
    const toTextFieldMobile = document.querySelector('#filter_price_max_show-mobile');
    fromTextFieldDesktop.innerText = fromValue;
    toTextFieldDesktop.innerText = toValue;
    fromTextFieldMobile.innerText = fromValue;
    toTextFieldMobile.innerText = toValue;
  }

  if (document.querySelector('.range_container')) {
    const fromSliderDesktop = document.querySelector('#fromSlider-desktop');
    const fromSliderMobile = document.querySelector('#fromSlider-mobile');
    const toSliderDesktop = document.querySelector('#toSlider-desktop');
    const toSliderMobile = document.querySelector('#toSlider-mobile');

    const fromInputDesktop = document.querySelector('#filter_price_min-desktop');
    const fromInputMobile = document.querySelector('#filter_price_min-mobile');
    const toInputDesktop = document.querySelector('#filter_price_max-desktop');
    const toInputMobile = document.querySelector('#filter_price_max-mobile');

    fillSlider(fromSliderDesktop, toSliderDesktop, toSliderDesktop);
    fillSlider(fromSliderMobile, toSliderMobile, toSliderMobile);
    setToggleAccessible(toSliderDesktop);
    setToggleAccessible(toSliderMobile);

    fromSliderDesktop.oninput = () => {
      controlFromSlider(fromSliderDesktop, toSliderDesktop, fromInputDesktop);
      updateSliderText(fromSliderDesktop, toSliderDesktop);
    };
    fromSliderMobile.oninput = () => {
      controlFromSlider(fromSliderMobile, toSliderMobile, fromInputMobile);
      updateSliderText(fromSliderMobile, toSliderMobile);
    };

    toSliderDesktop.oninput = () => {
      controlToSlider(fromSliderDesktop, toSliderDesktop, toInputDesktop);
      updateSliderText(fromSliderDesktop, toSliderDesktop);
    };
    toSliderMobile.oninput = () => {
      controlToSlider(fromSliderMobile, toSliderMobile, toInputMobile);
      updateSliderText(fromSliderMobile, toSliderMobile);
    };

    fromInputDesktop.oninput = () => controlFromInput(fromSliderDesktop, fromInputDesktop, toInputDesktop, toSliderDesktop);
    toInputDesktop.oninput = () => controlToInput(toSliderDesktop, fromInputDesktop, toInputDesktop, toSliderDesktop);
    fromInputMobile.oninput = () => controlFromInput(fromSliderMobile, fromInputMobile, toInputMobile, toSliderMobile);
    toInputMobile.oninput = () => controlToInput(toSliderMobile, fromInputMobile, toInputMobile, toSliderMobile);
  }
});

function applyCustomColorOfCheckmarks() {
  const colorCustomCheckboxImage = document.querySelectorAll('.custom-checkbox-color--image');
  colorCustomCheckboxImage.forEach(checkbox => {
    if (checkbox.classList.contains('custom_checkmark_color')) {
      const mainParent = checkbox.closest('li.facet');
      if (mainParent.tagName !== 'LI' || mainParent === null || mainParent === undefined) return;
      const mainParentIndex = mainParent.getAttribute('data-index');
      const customCheckmarkColor = checkbox.getAttribute('custom_checkmark_color');
      const style = document.createElement('style');

      style.textContent = `
          li.color-facet[data-index="${mainParentIndex}"]:has(input[type="checkbox"]:checked)  .custom-checkbox:not(.inactive)::after {
              border-color: ${customCheckmarkColor};
          }
      `;
      document.head.appendChild(style);
    }
  })
}

applyCustomColorOfCheckmarks();

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}